import React from "react"
import { InputWithLabel } from "./common"

const Email = ({
  dirty,
  edit,
  email,
  initialEmail,
  onFocus,
  onBlur,
  onChangeInput,
}) => (
  <InputWithLabel
    isEditing={dirty}
    edit={edit}
    label="Email"
    maxLength="256"
    showError={email.edited && !email.valid && !email.isActive}
    error={email.error}
    onFocus={onFocus("email")}
    onBlur={onBlur("email")}
    onChange={onChangeInput("email")}
    fieldType="email"
    value={email.edited ? email.value : initialEmail}
    required
  />
)

export { Email as default }



// WEBPACK FOOTER //
// ./assets/account/components/forms/Email.js